import React from 'react';
import cn from 'classnames';

import styles from '../Modal.module.scss';

type TFlatButton = {
  icon: React.ReactNode;
  onClick: (params?: any) => void;
  disabled?: boolean;
  lightIcon?: boolean;
  className?: string;
  datatest?:string
};

export const FlatButton: React.FC<TFlatButton> = ({ icon, lightIcon, disabled, onClick, children, className, datatest }) => (
  <button
    type="button"
    className={cn(styles.FlatButton, className)}
    onClick={onClick}
    disabled={disabled}
    data-test={datatest}
  >
    <span className={lightIcon ? styles.alticon : ''}>{icon}</span>
    {children && <span>{children}</span>}
  </button>
);
